/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Check"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M21.639 5.378a1.29 1.29 0 0 1-.01 1.8L10.254 18.632c-.487.49-1.271.49-1.758 0l-6.125-6.168a1.29 1.29 0 0 1-.01-1.8 1.234 1.234 0 0 1 1.768-.01l5.246 5.283 10.496-10.57a1.234 1.234 0 0 1 1.768.01"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const CheckIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'check-icon'}
      icon={Check}
      {...props}
      size={size}
    />
  );
};
